(() => {
  if (window.AlxSectionsReady) return;
  window.AlxSectionsReady = true;
  const ready = new WeakSet();
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = scope => {
    scope.querySelectorAll('[data-alx-stats]').forEach(section => {
      if (ready.has(section)) return;
      ready.add(section);
      if (section.dataset.animation !== 'true' || reduced()) return;
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        const values = [...section.querySelectorAll('[data-alx-count]')];
        const duration = Math.max(100, Number(section.dataset.duration) || 2500);
        const start = performance.now();
        const tick = now => {
          const progress = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          values.forEach(el => {
            const target = Number(el.dataset.alxCount);
            el.textContent = progress === 1 ? el.dataset.alxCount : String(Math.round(target * eased));
          });
          if (progress < 1 && section.isConnected) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }, { threshold: 0.15 });
      observer.observe(section);
    });
    scope.querySelectorAll('[data-alx-faq]').forEach(section => {
      if (ready.has(section)) return;
      ready.add(section);
      section.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
        if (detail.open && section.dataset.singleOpen === 'true') section.querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
      }));
    });
    scope.querySelectorAll('[data-alx-carousel]').forEach(section => {
      if (ready.has(section)) return;
      ready.add(section);
      const track = section.querySelector('[data-alx-carousel-track]');
      const cards = [...track.querySelectorAll('[data-alx-carousel-card]')];
      const previous = section.querySelector('[data-alx-carousel-prev]');
      const next = section.querySelector('[data-alx-carousel-next]');
      const page = section.querySelector('[data-alx-carousel-page]');
      const position = () => Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / ((cards[0]?.getBoundingClientRect().width || 1) + (parseFloat(getComputedStyle(track).gap) || 0)))));
      const paint = () => {
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        page.textContent = cards.length ? `${position() + 1} / ${cards.length}` : '';
      };
      const move = direction => track.scrollBy({ left: direction * ((cards[0]?.getBoundingClientRect().width || track.clientWidth) + (parseFloat(getComputedStyle(track).gap) || 0)), behavior: reduced() ? 'instant' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', paint, { passive: true });
      const observer = new ResizeObserver(() => { if (!section.isConnected) observer.disconnect(); else paint(); });
      observer.observe(track);
      paint();
    });
  };
  document.addEventListener('shopify:section:load', () => init(document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
})();
